export default "__VITE_ASSET__Bi5i9UG9__"